export default __webpack_public_path__ + "static/media/phone.da4610ad.svg";